export const formatDrugName = (name) => {
    return name?.replace(/\s+/g, ' ') ?? '';
};
